// routes
// styles
import "./App.css";
import "./styles/mobile-responsive.css";
import "./styles/smaller-responsive.css";
import "./styles/styles.css";
import AppRouting from "./utils/routing";

function App() {
  return <AppRouting />;
}

export default App;
